import { useState } from 'react';
import useList from '../../leads_component/shared-components/hooks/useList';

const useRuleApplyRange = (props) => {
  const model = props.model || 'add';

  const applyRange =
    model === 'edit' && props.data ? props.data : { applyRangeType: 'ALL', logicRelation: 'AND', applyRangeDetail: [] };

  const [applyRangeType, setApplyRangeType] = useState(applyRange.applyRangeType);

  const [logicRelation, setLogicRelation] = useState(applyRange.logicRelation);

  const applyRangeDetailHooks = useList({
    data: applyRange.applyRangeDetail,
    emptyItem: { fieldScope: 'STANDARD', fieldName: '', matchRelation: 'IN', fieldValues: [] },
  });

  const checkValid = () => {
    if (applyRangeType === 'CUSTOMIZE') {
      let hasError = false;
      applyRangeDetailHooks.dataList.forEach((ele, index) => {
        if (ele.fieldScope == 'STANDARD') {
          if (ele.fieldName == '' || ele.fieldValues.length == 0) {
            hasError = true;
            applyRangeDetailHooks.onItemChange(index, 'error', true);
          } else {
            applyRangeDetailHooks.onItemChange(index, 'error', null);
          }
        }
      });

      if (hasError) {
        return false;
      }
    }
    return true;
  };

  return {
    model,
    applyRange: {
      applyRangeType,
      logicRelation,
      applyRangeDetail: applyRangeDetailHooks.dataList,
    },
    applyRangeType,
    setApplyRangeType,
    logicRelation,
    setLogicRelation,
    applyRangeDetailHooks,
    checkValid,
  };
};

export default useRuleApplyRange;
